import { openerHoldMs, timelineDuration, type Clip } from "@hudhud/core";
import { FPS, msToFrame } from "./types.js";

/** Total frames: opener hold (full-screen opener before the speech) + cut video + end card. Overlay openers add no time. */
export function reelDurationFrames(clip: Clip): number {
  const speech = timelineDuration(clip.segments);
  const end = clip.endCard.enabled ? clip.endCard.durationMs : 0;
  return Math.max(FPS, Math.ceil(((openerHoldMs(clip) + speech + end) / 1000) * FPS));
}

export function speechDurationMs(clip: Clip): number {
  return timelineDuration(clip.segments);
}

export const openerHoldFrames = (clip: Clip) => msToFrame(openerHoldMs(clip));
